import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Button, Select, DatePicker, InputNumber, Form } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { meshLog, SPGet, SPSet } from '../../../utils/spUtils';
import { deviceNo } from "../../../const/infoConst";
import { searchPower1, searchPower2, searchPower3, downSearchPowerLog } from "../../../utils/net/netManager";
import { bigEndianToLittleEndian, transIntToHex2Str, getDaysBetweenDates, getRandomColor } from '../../../utils/dataUtils';
import { getNameBygroupID } from '../../../utils/deviceUtils';
import { getBleVer, getEnergyGroupArr, getEnergyMeshArr, getIDBygroupName } from '../../../utils/meshUtils';
import { changeEnergySelectBuilding } from '../../../utils/net/netUtils';
import energy from "../../../imgs/item/energy.png";
import './energyBarChart.less';

const energyData = {
    daily: Array.from({ length: 31 }, (_, i) => ({
        date: i + 1,
        value: Math.random() * 0.8 + 0.2,
    })),
};


export default class EnergyBarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            area: 'Area 13',
            timeGranularity: 'year',
            selectedDate: '2026-02-10',
            energySaving: 10,
            isCalcModalOpen: false,
            type: 3, //年月日判断3是年 2是月 1是日
            group: '1', //组的编号
            device: '',//单灯的编号
            energyDataType: 0, //判断选择的是什么，//0-area  1-group  2-device  3-log
            chartData: {},
            types_area:
                [{ value: 0, label: 'Area 13' },
                { value: 1, label: 'Area 12' },
                { value: 2, label: 'Area 11' }],
            types_group:
                [{ value: 0, label: 'group 13' },
                { value: 1, label: 'group 12' },
                { value: 2, label: 'group 11' }],
            HistoricalEnergy: '20kwh',
            Total: '15kwh',
            Price: "$1",
            SaveCost: '$5',
            //Energy Data
            multi: 0,

        };
        this.chartRef = React.createRef();
    }
    componentDidMount() {
        //判断选择的是什么 0-area  1-group  2-device  3-log
        PubSub.subscribe('energyDataType', (msg, data) => {
            //0-area  1-group  2-device
            this.setState({
                energyDataType: data,
                multi: data,
            });

            setTimeout(() => {
                this.goToSearchPower()
            }, 500)

        })
        //第一步获取当前时间
        this.getTimeOnline()
        // 刷新UI
        this.updatePageUI();

        setTimeout(() => {
            this.goToSearchPower()
        }, 500)

        PubSub.subscribe('changeEnergyMeshUpdateUI', (msg, data) => {
            this.updatePageUI();

            setTimeout(() => {
                this.goToSearchPower()
            }, 500)
        })

        PubSub.subscribe('goToEnergyBarChart', (msg, data) => {
            meshLog('单灯的图表信息', data);
            let groupId = data.groupID
            this.setState({
                device: data.macAddress,
                group: groupId.toString(),
                energyDataType: 2,
                multi: 1
            });

            setTimeout(() => {
                this.goToSearchPower()
            }, 500)

        })
    }


    //刷新UI
    updatePageUI() {
        //mesh
        let name = SPGet("energy_SelectMeshName");
        this.setState({
            mesh_arr: getEnergyMeshArr(),
            mesh_select: name,
        });
        //group
        let arrG = getEnergyGroupArr();
        let groupName = arrG[0].label;
        let groupId = getIDBygroupName(groupName)
        meshLog('arrG[0', arrG);
        SPSet("energy_SelectGroupName", groupName);
        this.setState({
            group_arr: arrG,
            group_select: groupName,
            group: groupId.toString(),
        });
        meshLog('wjk 模拟计量', name, groupName);
        this.getEmerGroupData(groupName);
    }


    //切换mesh下拉菜单
    handleMeshChange = (value) => {
        let name = getEnergyMeshArr()[value].label;
        meshLog('mesh', value, name);
        if (name == SPGet("energy_SelectMeshName")) return;

        let buildname = SPGet("energy_SelectBuildingName");
        changeEnergySelectBuilding(buildname, name);
    };

    //切换group下拉菜单
    handleGroupChange = (value) => {
        let name = getEnergyGroupArr()[value].label;
        meshLog('group', value, name);
        if (name == SPGet("energy_SelectGroupName")) return;
        let groupId = getIDBygroupName(name)
        SPSet("energy_SelectGroupName", name);
        meshLog('groupIdgroupIdgroupId', groupId);
        //切换group
        this.setState({
            group_select: name,
            group: groupId.toString(),
        });

        this.getEmerGroupData(name);

        setTimeout(() => {
            this.goToSearchPower()
        }, 500)
    };
    //获取刷选组的数据
    getEmerGroupData(name) {
        let lists = JSON.parse(SPGet("energy_groupList"));
        let group = lists.find(item => item.name == name)
        meshLog("profile里group数据:", group);
    }

    //获取当地时间
    getTimeOnline = () => {
        // 使用moment.js库获取当前日期
        var moment = require('moment');
        const offsetMinutes = new Date().getTimezoneOffset();
        const offsetHours = -offsetMinutes / 60;
        console.log(`UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`); // 输出示例: "UTC+8"
        console.log("offsetHours", offsetHours);
        let zoom = ''
        if (offsetHours > 0) {
            zoom = '+' + offsetHours
        } else {
            zoom = offsetHours
        }
        // 使用moment对象获取当前日期并格式化为yyyy-mm-dd
        var formattedDate = moment().format('YYYY-MM-DD');
        this.setState({
            selectedDate: formattedDate,
            // type: 3,
            zoom: zoom
        });
    }

    //数据查询
    goToSearchPower = async () => {
        meshLog('进行数据查询',);
        const jiliang = JSON.parse(SPGet("energy_jiliang"))
        const mac = bigEndianToLittleEndian(jiliang.macAddress)
        let token = (SPGet("token"));
        let meshUUID = (SPGet("energy_meshUUID"));
        let maddr = (SPGet("email"));
        let group = (this.state.group);
        let startDate = this.state.selectedDate
        let endDate = this.state.selectedDate
        let zoom = this.state.zoom
        let type = this.state.type //1代表24小时 ，2代表日  3代表月
        let energyDataType = this.state.energyDataType // //0-area  1-group  2-device  3-log
        let device = bigEndianToLittleEndian(this.state.device)
        let results = ''
        this.setState({
            chartData: {},
        });
        // let getDaysBetweenDate = getDaysBetweenDates(startDate, endDate)
        if (energyDataType == 0) {
            meshLog('返回的数据是area的',);
            results = await searchPower1(deviceNo, maddr, token, mac, startDate, endDate, type, meshUUID, zoom)
        } else if (energyDataType == 1) {
            meshLog('返回的数据是组的',);
            results = await searchPower2(deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom)
        } else if (energyDataType == 2) {
            meshLog('返回的数据是单灯的',);
            results = await searchPower3(deviceNo, maddr, token, group, mac, startDate, endDate, type, meshUUID, zoom, device)
        }
        meshLog('计量接口返回值1', results);
        const { code, msg } = results;
        if (code == 0) {
            const Total = msg.current
            const overDay = msg.last
            let LastDay = 0
            if (overDay == 0) {
                LastDay = 0
            } else {
                LastDay = parseInt(((Math.abs(overDay - Total)) / overDay) * 100)
            }
            const powerList = msg.powerList
            let data = []
            let downloadDeviceInfo = []

            if (type == 3) {
                meshLog('图表的数据年',);
                data = [
                    { "date": 'Jan', "value": 0 }, { "date": "Feb", "value": 0 }, { "date": "Mar", "value": 0 },
                    { "date": "Apr", "value": 0 }, { "date": "May", "value": 0 }, { "date": "Jun", "value": 0 },
                    { "date": "Jul", "value": 0 }, { "date": "Aug", "value": 0 }, { "date": "Sep", "value": 0 },
                    { "date": "Oct", "value": 0 }, { "date": "Nov", "value": 0 }, { "date": "Dec", "value": 0 }
                ]

                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < powerList.length; i++) {
                        if (index == parseInt((powerList[i].date).slice(-2)) - 1) {
                            data[index] = {
                                'date': data[index].date,
                                'value': Number(powerList[i].power),
                            }
                        }

                    }

                }
            } else if (type == 2) {
                meshLog('图表的数据月',);
                data = [
                    { "date": 1, "value": 0 }, { "date": 2, "value": 0 }, { "date": 3, "value": 0 },
                    { "date": 4, "value": 0 }, { "date": 5, "value": 0 }, { "date": 6, "value": 0 },
                    { "date": 7, "value": 0 }, { "date": 8, "value": 0 }, { "date": 9, "value": 0 },
                    { "date": 10, "value": 0 }, { "date": 11, "value": 0 }, { "date": 12, "value": 0 }, { "date": 13, "value": 0 },
                    { "date": 14, "value": 0 }, { "date": 15, "value": 0 }, { "date": 16, "value": 0 },
                    { "date": 17, "value": 0 }, { "date": 18, "value": 0 }, { "date": 19, "value": 0 },
                    { "date": 20, "value": 0 }, { "date": 21, "value": 0 }, { "date": 22, "value": 0 },
                    { "date": 23, "value": 0 }, { "date": 24, "value": 0 }, { "date": 25, "value": 0 },
                    { "date": 26, "value": 0 }, { "date": 27, "value": 0 }, { "date": 28, "value": 0 },
                    { "date": 29, "value": 0 }, { "date": 30, "value": 0 }, { "date": 31, "value": 0 },
                ]
                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < powerList.length; i++) {
                        if (index == parseInt((powerList[i].date).slice(-2)) - 1) {
                            data[index] = {
                                'date': parseInt((powerList[i].date).slice(-2)),
                                'value': Number(powerList[i].power),
                            }
                        }

                    }

                }
            } else if (type == 1) {
                meshLog('图表的数据日',);
                data = [
                    { "date": "00:00", "value": 0 }, { "date": "1:00", "value": 0 }, { "date": "2:00", "value": 0 },
                    { "date": "3:00", "value": 0 }, { "date": "4:00", "value": 0 }, { "date": "5:00", "value": 0 },
                    { "date": "6:00", "value": 0 }, { "date": "7:00", "value": 0 }, { "date": "8:00", "value": 0 },
                    { "date": "9:00", "value": 0 }, { "date": "10:00", "value": 0 }, { "date": "11:00", "value": 0 },
                    { "date": "12:00", "value": 0 }, { "date": "13:00", "value": 0 }, { "date": "14:00", "value": 0 },
                    { "date": "15:00", "value": 0 }, { "date": "16:00", "value": 0 }, { "date": "17:00", "value": 0 },
                    { "date": "18:00", "value": 0 }, { "date": "19:00", "value": 0 }, { "date": "20:00", "value": 0 },
                    { "date": "21:00", "value": 0 }, { "date": "22:00", "value": 0 }, { "date": "23:00", "value": 0 },
                ]

                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < powerList.length; i++) {
                        if (index == parseInt((powerList[i].date).slice(-2))) {
                            data[index] = {
                                'date': data[index].date,
                                'value': Number(powerList[i].power),
                            }
                        }

                    }

                }
                meshLog('resultDate', data);
            }


            const result1 = {
                daily: data.map(item => ({
                    date: item.date,
                    value: item.value
                }))
            };
            meshLog('图表的数据', result1);

            for (let index = 0; index < powerList.length; index++) {
                downloadDeviceInfo[index] = {
                    'date': (powerList[index].date),
                    'power': powerList[index].power,
                    'group': getNameBygroupID(powerList[index].groupAddr),
                    'mac': powerList[index].mac,
                }
            }

            meshLog(' Math.trunc(Total * 10) / 10', Math.trunc(Total * 10) / 10);
            this.setState({
                // Total: Total + 'kwh',
                Total: Math.trunc(Total * 10) / 10 + 'kwh',
                chartData: result1,
                overDay: overDay,
                LastDay: LastDay,
                downloadDeviceInfo: downloadDeviceInfo,
            });
        } else {
            this.setState({
                Total: 0,
                chartData: {},
                overDay: 0,
                LastDay: 0,
                downloadDeviceInfo: [],
            });

        }

    }

    //判断选择的是年月日
    handleGranularityChange = (granularity) => {
        let type = 1
        if (granularity == 'year') {
            type = 3
        } else if (granularity == 'month') {
            type = 2
        } else {
            type = 1
        }

        this.setState({
            timeGranularity: granularity,
            type: type
        });

        setTimeout(() => {
            this.goToSearchPower()
        }, 500)
    }

    //选择居具体的时间，然后要走数据查询
    handleDateChange = (date) => {
        // 将日期格式化为 YYYY-MM-DD
        const formattedDate = date ? date.format('YYYY-MM-DD') : null;
        console.log('格式化后的日期:', formattedDate);
        this.setState({
            selectedDate: formattedDate,
        });

        setTimeout(() => {
            this.goToSearchPower()
        }, 500)
    }
    //下载按钮
    downloadGroupEnergyLog = async (value) => {
        meshLog('valuevalue', value);//1代表xml 2代表csv
        let maddr = (SPGet("email"));
        let MeshName = (SPGet("SelectMeshName"));
        const result = this.state.downloadDeviceInfo
        meshLog('MeshName', MeshName);
        //这边是应急下载的逻辑
        if (result == '') {
            meshLog('result空', result);
        } else {
            meshLog('result有值', result);
            try {
                let results = await downSearchPowerLog(result, maddr, MeshName, value)
                meshLog('resultsresults', results);
                if (results.code == 0) {
                    const fileUrl = results.msg.url;
                    // window.open(fileUrl, '_blank');

                    const a = document.createElement('a');
                    a.href = fileUrl;
                    //a.download = '日志文件.log';  // 只对同源 URL 生效
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                } else {
                    alert("请输入正确的参数")
                }
            } catch (error) {
                console.error('下载错误:', error);
                alert("下载失败: " + error.message);
            }
        }

    }

    handleAreaChange = (value) => {
        this.setState({ area: value });
        meshLog('valuevaluevaluevalue', value);
    }

    cancelClick = () => {
        meshLog('取消1');
        this.setState({
            isCalcModalOpen: false,
        });
    };

    handleSubmit = async (values) => {
        meshLog('确认');
        const Total = this.state.Total
        const HistoricalEnergy = this.state.HistoricalEnergy
        let energySaving
        if (Total && typeof Total === 'string') {
            let TotalValue = parseInt(Total.replace("kwh", ""))
            let HistoricalEnergyValue = parseInt(HistoricalEnergy.replace("kwh", ""))
            energySaving = Math.round(((HistoricalEnergyValue - TotalValue) / HistoricalEnergyValue) * 100)
            meshLog('energySaving', energySaving);
            meshLog('TotalValue', TotalValue);
            meshLog('HistoricalEnergyValue', HistoricalEnergyValue);
            this.setState({ energySaving: energySaving });
        }

        this.setState({
            isCalcModalOpen: false,
        });
    }

    //处理方法
    handleChange2 = (key, value) => {
        //边输入边赋值 只改状态，不发送指令，，统一到最后修改
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
    };

    handleKeyUp = (event, key, value) => {
        if (event.key === 'Enter') {
            // 在这里执行你的方法
            meshLog('event', event);
            meshLog('key', key);
            console.log('Input value:', value);
            if (/^\d*$/.test(value)) { // 确保输入为数字序列或空字符串结束
                let valueR
                let valueX
                if (key == 'HistoricalEnergy') {
                    valueR = value + 'kwh'; // 添加内容到输入框
                } else if (key == 'Price') {
                    valueR = '$' + value
                    const Total = this.state.Total
                    const HistoricalEnergy = this.state.HistoricalEnergy
                    if (Total && typeof Total === 'string') {
                        let TotalValue = parseInt(Total.replace("kwh", ""))
                        let HistoricalEnergyValue = parseInt(HistoricalEnergy.replace("kwh", ""))
                        let SaveCost = (HistoricalEnergyValue - TotalValue) * value
                        this.setState({ SaveCost: '$' + SaveCost });
                    }
                }
                this.setState({ [key]: valueR });
            } else {
                // 如果不符合条件，可以清除或修改已输入的内容（可选）
                value = 0; // 仅保留数字，移除非数字字符（如果需要）
                meshLog('valuevalue', value);
                this.setState({ [key]: value });
            }

        }

    }

    OnclickIsCalcModalOpen = () => {
        this.setState({ isCalcModalOpen: true })
    }
    render() {
        const { area, timeGranularity, selectedDate, energySaving, chartData, HistoricalEnergy, Total, Price, SaveCost, SaveEnergy } = this.state;
        return (
            <div className="energy-page">
                <div className="energy-header" style={{ height: this.state.multi == 1 ? "210px" : "140px" }}>
                    <div className="area-tolte">
                        <span style={{ display: this.state.multi == 0 ? "flex" : "none" }} >Energy Data - Area</span>
                        <span style={{ display: this.state.multi == 1 ? "flex" : "none" }}  >Energy Data - Group</span>
                    </div>
                    <div className="area-select_1">
                        <span className='select_1_title'>Statistics Area</span>
                        <Select
                            className="energy_dropdown_mesh"
                            value={this.state.mesh_select}
                            onChange={this.handleMeshChange}
                            options={this.state.mesh_arr}
                        />
                    </div>

                    <div className="area-select_2" style={{ visibility: this.state.multi == 1 ? "visible" : "hidden" }}>
                        <span className='select_2_title'>Statistics Group</span>
                        <Select
                            className="energy_dropdown_group"
                            value={this.state.group_select}
                            onChange={this.handleGroupChange}
                            options={this.state.group_arr}
                        />
                    </div>
                </div>


                <div className="energy-title">
                    <div className="time-controls">
                        <Button style={{ background: this.state.timeGranularity == 'year' ? "#0B47BE" : "" }} onClick={() => this.handleGranularityChange('year')}>Display by Year</Button>
                        <Button style={{ background: this.state.timeGranularity == 'month' ? "#0B47BE" : "" }} onClick={() => this.handleGranularityChange('month')} active>Display by Month</Button>
                        <Button style={{ background: this.state.timeGranularity == 'day' ? "#0B47BE" : "" }} onClick={() => this.handleGranularityChange('day')}>Display by Day</Button>
                    </div>
                    <div className="download-buttons">
                        <Button style={{ background: "#0B47BE", color: 'white' }} onClick={() => { this.downloadGroupEnergyLog(1) }} icon={<DownloadOutlined />}>Download Excel Chart </Button>
                        <Button style={{ background: "#0B47BE", color: 'white' }} onClick={() => { this.downloadGroupEnergyLog(2) }} icon={<DownloadOutlined />}>Download chart CSV</Button>
                    </div>
                </div >
                <div className="energy-title">
                    <DatePicker picker={timeGranularity} onChange={(dateString) => this.handleDateChange(dateString)} />
                    {/* <div onClick={() => this.setState({ isCalcModalOpen: true })} className="energy-saving">Energy Saving: {energySaving}% </div > */}
                    <div onClick={() => this.OnclickIsCalcModalOpen()} className="energy-saving">Energy Saving: {energySaving}% </div >

                    {/* <DatePicker picker={timeGranularity} />
                    <div className="energy-saving">Energy Saving: {energySaving}% </div > */}
                </div >
                <div className="chart-container" >
                    kWh
                    <ResponsiveContainer width="100%" height={450}>
                        <BarChart margin={{ top: 20, right: 30, left: 60, bottom: 20 }} barCategoryGap={15} maxBarSize={50} data={chartData.daily} ref={this.chartRef}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="date" />
                            <YAxis domain={[0, 5]} />
                            <Tooltip />
                            <Bar dataKey="value" fill="#16B757" radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div className="calc-modal" style={{ visibility: this.state.isCalcModalOpen ? "visible" : "hidden" }} >
                    <div  >
                        <div className="item_title">
                            <img src={energy} />
                            <span>Energy Consumption Analysis</span>
                        </div>

                        <div className="HistoricalEnergy">
                            <div className="sensor-title">
                                <span>Historical Energy Consumption</span>
                            </div>
                            <div className="box">
                                <input style={{ width: 65 }} type="text" value={HistoricalEnergy} onKeyUp={(event) => this.handleKeyUp(event, 'HistoricalEnergy', event.target.value)} onChange={(e) => this.handleChange2('HistoricalEnergy', e.target.value)} />
                            </div>
                        </div>

                        <div className="HistoricalEnergy">
                            <div className="sensor-title">
                                <span>Actual Energy Consumption</span>
                            </div>
                            <div className="box">
                                <input disabled style={{ width: 65 }} type="text" value={Total} onKeyUp={(event) => this.handleKeyUp(event, 'Total', event.target.value)} onChange={(e) => this.handleChange2('Total', e.target.value)} />
                            </div>
                        </div>

                        <div className="HistoricalEnergy">
                            <div className="sensor-title">
                                <span>Energy Unit Price</span>
                            </div>
                            <div className="box">
                                <input style={{ width: 65 }} type="text" value={Price} onKeyUp={(event) => this.handleKeyUp(event, 'Price', event.target.value)} onChange={(e) => this.handleChange2('Price', e.target.value)} />
                            </div>
                        </div>

                        <div className="HistoricalEnergy2">
                            <div className="sensor-title">
                                <span>Energy Cost Savings</span>
                            </div>
                            <div className="box">
                                <input disabled style={{ width: 65 }} type="text" value={SaveCost} onKeyUp={(event) => this.handleKeyUp(event, 'SaveCost', event.target.value)} onChange={(e) => this.handleChange2('SaveCost', e.target.value)} />
                            </div>
                        </div>
                        <div className="Energy-footer">
                            <button className='cancelBtn' onClick={() => this.cancelClick()}>Cancel</button>
                            <button className='okBtn' onClick={() => this.handleSubmit()} >Confirm</button>
                        </div>

                    </div>
                </div>

            </div >
        );
    }
}
